










import { InputLabel, AltInputLabel, InputError, ProfileImage } from '../../atoms'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    InputLabel,
    AltInputLabel,
    InputError,
    ProfileImage
  }
})
export default class ImageGroup extends Vue {
  @Prop({ type: String, default: '' }) readonly label?: string
  @Prop({ type: String, default: '' }) readonly altLabel?: string
  @Prop({ type: String, default: 'text' }) readonly type?: string
  @Prop({ type: String, default: '' }) readonly error?: string
  @Prop({ type: Boolean, default: false }) readonly hiddenField?: boolean
  @Prop({ type: Boolean, default: false }) readonly disabled?: boolean
  @Prop({ type: String, default: '' }) readonly containerCustomStyle?: string
  @Prop({ type: String, default: '' }) readonly customStyle?: string
  @Prop({ type: String, default: '' }) readonly image?: string
}
